import qs from 'querystring';
import conf from '../conf';

// GENERIC CALL
export const genericFetch = (url, method) => fetch(url, method)
  .then(response => response.json());

// GENERIC SECU
const { oauthTokenUrl } = conf;
let oauthAuthorization;
const getOAuthAuthorization = async () => {
  if (oauthAuthorization === undefined) {
    oauthAuthorization = await genericFetch(oauthTokenUrl, {
      method: 'POST',
      body: qs.stringify(conf.oauthCredentials),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    })
      .then(obj => `Bearer ${obj.access_token}`);
  }
  return oauthAuthorization;
};

// GENERIC CALL API WITH AUTH
const makeCallApi = getAuthorization => async (url, config = {}) => {
  const Authorization = await getAuthorization();

  const params = qs.stringify(config.params);
  const fullUrl = [url, params].join('?')

  return genericFetch(fullUrl, {
    method: 'GET',
    headers: { Authorization }
  });
};

const callApi = makeCallApi(getOAuthAuthorization);
export default callApi;

// GET SHELTERS (Arras)/ STUDIO(bourgogne)
const { studioUrl } = conf;
export const getStudio = (config) => callApi(studioUrl, config);



// WEBPACK FOOTER //
// src/service/data.js